import React, {memo} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import styles from "./VideoInfoPanel.module.css";
import {Video} from "../../../../common/video/models/Video";
import VideoMetadataLine from "../../../../common/components/videoMetadataLine/VideoMetadataLine";
import {VideoTag} from "../../../../common/video/models/VideoTag";
import Tag from "../../../../common/components/tag/Tag";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import useResponsive from "../../../../common/useResponsive";
import {resetfilter} from "../../../../common/video/VideoFilterActions";
import {isEmpty} from "lodash";

interface VideoInfoPanelProps {
    video: Video;
}

function VideoInfoPanel({video}: VideoInfoPanelProps) {
    const {isMobile} = useResponsive();
    const dispatch = useDispatch();
    const history = useNavigate();

    const handleClick = (tagName: string) => {
        const videoFilter = {
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: [tagName]
        };
        dispatch(resetfilter(videoFilter));
        setTimeout(() => history("/videos"), 100);
    };
    return (
        <div className={styles.root}>
            <div className={styles.countRow}>
                <VideoMetadataLine variant="normal" bold={true} fontSize={isMobile ? 12 : 16} video={video}/>
            </div>

            {
                !isEmpty(video.tags) &&
                <div className={styles.tagList}>
                    <div className={styles.tagListLabel}>
                        <PuiTypography size={14} bold={true} color="gray-61">Tags:</PuiTypography>
                    </div>
                    {video.tags.map((tag: VideoTag) => (
                        <Tag key={tag} tag={tag} onClick={handleClick}/>
                    ))}
                </div>
            }

            <div className={styles.title} data-tip={video.title} data-for="title">
                <PuiTypography bold={true} size={isMobile ? 24 : 40}>{video.title}</PuiTypography>
            </div>
            <PuiTooltip id={"title"}/>

            <div className={styles.description}>
                <PuiTypography size={isMobile ? 16 : 20}>{video.description}</PuiTypography>
            </div>
        </div>
    );
}

export default memo(VideoInfoPanel);
